import ShopType from "@/enum/ShopType";

const ShopTypeNameMap = {
    [ShopType.TAOBAO]: "淘宝",

    [ShopType.TAOBAO_DISTRIBUTION]: "天猫供销",

    [ShopType.ALIBABA]: "阿里巴巴",

    [ShopType.ALIBABA_SUPPLIER]: "阿里巴巴代发",

    [ShopType.JD]: "京东",

    [ShopType.JD_PURCHASE]: "京东供销",

    [ShopType.YOUZAN]: "有赞",

    [ShopType.WEIDIAN]: "微店",

    [ShopType.MEILISHUO]: "美丽说",

    [ShopType.MOGUJIE]: "蘑菇街",

    [ShopType.SUNING]: "苏宁",

    [ShopType.AMAZON]: "亚马逊",

    [ShopType.ZHE800]: "折800",

    [ShopType.WEIMOB]: "微盟",

    [ShopType.PINDUODUO]: "拼多多",

    [ShopType.PDD_FDS]: "拼多多代发",

    [ShopType.KWAI]: "快手",

    [ShopType.JUANPI]: "卷皮",

    [ShopType.DANGDANG]: "当当",

    [ShopType.CHUCHUJIE]: "楚楚街",

    [ShopType.CHUCHUJIE_PINTUAN]: "楚楚街拼团",

    [ShopType.FANLI]: "返利",

    [ShopType.MENGDIAN]: "萌店",

    [ShopType.WEIMOB_EC]: "微盟EC",

    [ShopType.HUIGUO]: "会过",

    [ShopType.DALINGJIA]: "达令家",

    [ShopType.GLOBAL_SCANNER]: "环球捕手",

    [ShopType.API_INTEGRATION]: "API店铺",

    [ShopType.MANUAL]: "手工店铺",

    [ShopType.CHUCHUTONG]: "楚楚通",

    [ShopType.XIAODIAN]: "小店",

    [ShopType.FANGXINGOU]: "放心购",

    [ShopType.DOUDIAN]: "抖店",

    [ShopType.XIAOHONGSHU]: "小红书",

    [ShopType.ALI_C2M]: "淘工厂",

    [ShopType.DUXIAODIAN]: "度小店",

    [ShopType.WEBUY]: "好衣库",

    [ShopType.HAIZIWANG]: "孩子王",

    [ShopType.AIKUCUN]: "爱库存",

    [ShopType.AIKUCUN_V2]: "爱库存V2",

    [ShopType.SDMM]: "神灯妈妈",

    [ShopType.FKW]: "凡科网",

    [ShopType.FKMDT]: "凡科门店通",

    [ShopType.HKMDXT]: "华可门店系统",

    [ShopType.WSC]: "唯商城",

    [ShopType.KTT]: "快团团",

    [ShopType.YMDY]: "一美大院",

    [ShopType.HCTY]: "贞德爱心益站",

    [ShopType.DOUDIAN_IOP]: "抖店代发",

    [ShopType.DOUDIAN_SUPPLIER]: "抖店供应链",

    [ShopType.KWAI_DROPSHIP]: "快手厂家代发",

    [ShopType.CHANNEL_SHOP]: "微信小店",

    [ShopType.CHANNEL_SHOP_DROPSHIP]: "微信小店供货商代发",

    [ShopType.CHANNEL_SHOP_SUPPLIER]: "微信小店供货商供货",

    [ShopType.DOUBB]: "播城",

    [ShopType.PDD_FULFILLMENT]: "拼多多跨境",

    [ShopType.INDEPENDENT_MANUAL]: "自由打印版",

    [ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER]: "淘系代发(供货商)",

    [ShopType.PDD_DROP_SHIPPING_SUPPLIER]: "拼多多代发(供货商)",

    [ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER]: "抖音代发(供货商)",

    [ShopType.JD_DROP_SHIPPING_SUPPLIER]: "京东代发(供货商)",

    [ShopType.OTHER_DROP_SHIPPING_SUPPLIER]: "其他代发(供货商)",
};

export default ShopTypeNameMap;
